import { EBOOK_INTERACTIVE } from 'global/constants';
import {
  StimulusLibrary,
  StimulusLibraryCreate,
} from '../shared/stimulus-library';
import { Props } from '../interactive/interactive-settings.constants';
import InteractiveEditDrawer from '../interactive/interactive-edit-drawer';
import { getStimulusLabel } from '../shared/logic/get-stimulus-label';

const InteractiveEbookSettings = (props: Props) => {
  return props.properties.stimulusId ? (
    <InteractiveEditDrawer
      title={getStimulusLabel(EBOOK_INTERACTIVE)}
      {...props}
    />
  ) : (
    <StimulusLibrary
      stimulusType={EBOOK_INTERACTIVE}
      componentId={props.id}
      title={getStimulusLabel(EBOOK_INTERACTIVE)}
      canGoBack={false}
      headerActionButton={
        <StimulusLibraryCreate
          sectionId={props.sectionId}
          componentId={props.id}
          contentId={props.lessonId}
          type={EBOOK_INTERACTIVE}
        />
      }
      {...props}
    />
  );
};

export default InteractiveEbookSettings;
